export default __webpack_public_path__ + "static/media/usdt.52dffb35.svg";